"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.post.saved': '帖子已保存',
    'socialMediaPlan.post.saveFailed': '保存失败',
    'socialMediaPlan.post.publish': '立即发布',
    'socialMediaPlan.post.publishedOn': '发布于',
    'socialMediaPlan.post.publishFailed': '发布失败于',
    'socialMediaPlan.post.publishError': '发布失败，请重试。',
    'socialMediaPlan.post.duplicated': '已复制',
    'socialMediaPlan.post.duplicateFailed': '复制失败',
    'socialMediaPlan.post.deleted': '已删除',
    'socialMediaPlan.post.deleteFailed': '删除失败',
    'socialMediaPlan.post.deleteConfirm': '确认删除此帖子？',
};
